import React, {FunctionComponent} from 'react';

type BackLinkProps = {
  backLink: string
  title?: string
}

/**
 * 'Back' link on the form
 * @param backLink {string} Path to the 'Back' page
 * @param title {string} Title of the 'Back' link. If empty, then 'Back'
 * @return {JSX.Element}
 * @constructor
 */
const BackLink: FunctionComponent<BackLinkProps> = ({backLink, title}) =>
  (
    <a href={backLink} className="pt-5 pb-3 text-blue block">&larr; {title || 'Back'}</a>
  );


export default BackLink;
